module.exports = __webpack_public_path__ + "img/map.bbda6376.png";